'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$version$split = _react2.default.version.split('.'),
    _React$version$split2 = _slicedToArray(_React$version$split, 1),
    reactMajorVersion = _React$version$split2[0];

var canReturnArray = parseInt(reactMajorVersion, 10) >= 16;

var RenderArrayOrDiv = function RenderArrayOrDiv(_ref) {
  var children = _ref.children,
      Wrapper = _ref.as,
      others = _objectWithoutProperties(_ref, ['children', 'as']);

  return Wrapper ? _react2.default.createElement(
    Wrapper,
    others,
    children
  ) : _react2.default.Children.toArray(children);
};

if (process.env.NODE_ENV !== 'production') {
  RenderArrayOrDiv.propTypes = {
    as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    children: _propTypes2.default.node.isRequired
  };
}

RenderArrayOrDiv.defaultProps = {
  as: canReturnArray ? undefined : 'div'
};

var Fragment = _react2.default.Fragment ? _react2.default.Fragment : RenderArrayOrDiv;

exports.default = Fragment;